"use strict";
/*
 * @author Tommy Brière
 * @copyright (c) 2015 Groupe PVP
 * @fileoverview TODO
 */
(function ($g, createjs) {

    var Tween = createjs.Tween;

    function Video(stage, vPlayer, data) {

        var me = this;
        var timeline;
        var cjsitem = new createjs.Container();
        var owidth = 0;
        var oheight = 0;

        var vwidth = 0;
        var vheight = 0;
        var duration = data.duration;
        var directDisplay = true;
        me.duration = duration;
        me.haveAudio = data.audio;

        

        function drawImage() {
            var v = false;
            if (vPlayer.ready && vwidth > 10 && vheight > 10) {
                try {
                    var ctx = cjsitem.cacheCanvas.getContext("2d");
                    //iOS 11 use video buffer directly...  
                    //Fix 1: use true video object
                    ctx.drawImage(vPlayer.video, 0, 0, vwidth, vheight);
                    v = true;
                } catch (e) {
                    $g.exception(e, false, true);
                }                    
            }
            cjsitem.visible = v;//Fix crash IOS 11            
        }

        function change() {
            if (directDisplay) {
                const video = vPlayer.video;
                if (video && vPlayer.ready && !video.parentNode) {
                    stage.canvas.parentNode.appendChild(video);
                }
                return;
            }
            if (cjsitem.parent && vPlayer.video) {
                var cwidth = stage.canvas.width;
                var cheight = stage.canvas.height;
                if (vPlayer.ready) {
                    vwidth = vPlayer.video.videoWidth;
                    vheight = vPlayer.video.videoHeight;
                    var orw = cwidth / vwidth;
                    var orh = cheight / vheight;
                    var ormin = Math.min(1, orw, orh);
                    vwidth = (vwidth * ormin) | 0;
                    vheight = (vheight * ormin) | 0;
                }
                if (vwidth > 10 && vheight > 10 ) {
                    if (!cjsitem.cacheCanvas || (owidth !== vwidth) || (oheight !== vheight)) {
                        cjsitem.cache(0, 0, vwidth, vheight);
                        owidth = vwidth;
                        oheight = vheight;
                    }

                    // Drawing
                    drawImage();

                    var rw = cwidth / vwidth;
                    var rh = cheight / vheight;
                    var rmin = Math.min(rw, rh);
                    var cx = cwidth * 0.5;
                    var cy = cheight * 0.5;
                    cjsitem.regX = vwidth / 2;
                    cjsitem.regY = vheight / 2;
                    cjsitem.x = cx;
                    cjsitem.y = cy;
                    cjsitem.scaleX = rmin;
                    cjsitem.scaleY = rmin;                    
                }
            }
        }

        function clear() {
            if (cjsitem && cjsitem.parent) {//TODO Arrêter de jouer le vidéo
                cjsitem.parent.removeChild(cjsitem);
                if (vPlayer.current == data.url) {
                    vPlayer.current = null;
                }
            }
            if (directDisplay) {
                const video = vPlayer.video;
                if (video && video.parentNode) {
                    video.parentNode.removeChild(video);
                    //video.setAttribute("hwz", "off");
                }
                if (vPlayer.current === data.url) {
                    vPlayer.current = null;
                }
            }
        }

        function appear(parent, isPrev) {
            if (isPrev) {
                return;
            }
            vPlayer.current = data.url;
            if (!directDisplay) {
                parent.addChild(cjsitem);
                //const video = vPlayer.video;
                //video.setAttribute("hwz", "z-index:1");
            }
            change();
        }

        function init() {
            timeline = Tween.get(cjsitem, {paused: true, onChange: change});
            me.timeline = timeline;
            timeline
                    .to({t: 1}, 0)
                    .wait(duration)
                    .to({t: 0}, 0);
        }

        Object.defineProperties(this, {
            ready: {
                get: function() {
                    return vPlayer.ready||vPlayer.error;
                } 
            },
            error: {
                get: function() {
                    if (vPlayer.current == data.url) {
                        return vPlayer.error;
                    }
                }
            },
            directDisplay: {
                get: function() {
                    return directDisplay;
                },
                set: function(value) {
                    value = !!value;
                    if (value != directDisplay) {
                        clear();
                        directDisplay = value
                    }
                }
            }

        });
        me.stillFrame = function() {
            if (cjsitem.parent && vPlayer.video && !directDisplay) {
                drawImage();           
            }
        };
        me.show = appear;
        me.hide = clear;
        me.resize = function () {};
        me.seek = function() {
            var p = timeline.position || 0;
            vPlayer.currentTime = p;
        };

        init();
    }

    $g.Video = Video;

})(PVPGEngine, createjs, Math);
